import React from 'react'

import { CTALink } from 'marketing-site/src/mvp/library/elements/CTALink'
import { Text } from 'marketing-site/src/library/elements/Text'
import { IHeaderNavigationMenuDescription } from '../index'

export const HeaderNavigationMenuDescription = ({
  contentType = 'flex',
  title,
  subhead,
  cta,
}: IHeaderNavigationMenuDescription): React.ReactElement => {
  return (
    <>
      <div className="menu-description">
        <div className="menu-description__title">
          <Text brand={contentType === 'flex' ? 'default' : 'mvp'} size="heading-3">
            {title}
          </Text>
        </div>
        {subhead && (
          <div className="menu-description__subhead">
            <Text brand={contentType === 'flex' ? 'default' : 'mvp'} size="body">
              {subhead}
            </Text>
          </div>
        )}
        {cta && (
          <div className="menu-description__cta">
            <CTALink {...cta} />
          </div>
        )}
      </div>

      <style jsx>{`
        .menu-description {
          display: grid;

          &__subhead {
            margin-top: 0.75rem;
          }

          &__cta {
            margin-top: 0.75rem;
          }
        }
      `}</style>
    </>
  )
}
